import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const SupplierListing = () => {
  const [suppliers, setSuppliers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedService, setSelectedService] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 9;

  useEffect(() => {
    axios
      .get(" https://backend-zkgn.onrender.com/api/suppliers")
      .then((res) => {
        setSuppliers(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch suppliers:", err);
      });
  }, []);

  // Get unique service options
  const serviceOptions = [
    "All",
    ...new Set(suppliers.map((s) => s.providers_of)),
  ];

  // Filtered suppliers
  const filteredSuppliers = suppliers.filter((supplier) => {
    const matchesSearch = `${supplier.supplier_name} ${supplier.providers_of}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesService =
      selectedService === "All" ||
      supplier.providers_of.toLowerCase() === selectedService.toLowerCase();
    return matchesSearch && matchesService;
  });

  // Sort alphabetically
  const sortedSuppliers = [...filteredSuppliers].sort((a, b) =>
    a.supplier_name.localeCompare(b.supplier_name)
  );

  // Pagination logic
  const totalPages = Math.ceil(sortedSuppliers.length / pageSize);
  const paginatedSuppliers = sortedSuppliers.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  // Reset page when filters/search change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedService]);

  // Navigate between pages
  const goToPreviousPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  // Compact pagination logic (like ClassifiedListing)
  const getPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="container-fluid my-5">
      {/* Count */}
      <div className="text-left mb-3">
        <h5 className="fw-bold text-tertiry">
          <strong>{filteredSuppliers.length}</strong> - Suppliers Found
        </h5>
      </div>

      {/* Search and Filter */}
      <div className="row mb-4">
        <div className="col-md-6 mb-2">
          <input
            type="text"
            placeholder="Search by supplier or service"
            className="form-control"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="col-md-6 mb-2">
          <select
            className="form-select"
            value={selectedService}
            onChange={(e) => setSelectedService(e.target.value)}
          >
            {serviceOptions.map((service, index) => (
              <option key={index} value={service}>
                {service}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* No Results */}
      {filteredSuppliers.length === 0 ? (
        <p>No suppliers match your criteria.</p>
      ) : (
        <>
          {/* Supplier Cards */}
          <div className="row">
            {paginatedSuppliers.map((supplier, index) => (
              <div className="col-lg-4 col-md-6 mb-4" key={index}>
                <div className="card shadow-sm supplier-card">
                  <div className="card-body">
                    <h5 className="card-title mb-2">
                      <Link
                        to={`/supplier/${
                          supplier.supplier_id
                        }/${supplier.supplier_name.replace(/\s+/g, "-")}`}
                        className="supplier-link text-decoration-none"
                      >
                        <strong>{supplier.supplier_name}</strong>
                      </Link>
                    </h5>
                    <p className="card-text plantdetails mb-1">
                      <span className="label">Address:</span> {supplier.address}
                    </p>
                    <p className="card-text plantdetails mb-1">
                      <span className="label">We are providers of:</span>{" "}
                      {supplier.providers_of}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Compact Pagination */}
          {totalPages > 1 && (
            <nav className="d-flex justify-content-center mt-4">
              <ul className="pagination pagination-sm flex-wrap shadow-sm">
                {/* Previous */}
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={goToPreviousPage}>
                    ← Previous
                  </button>
                </li>

                {/* Page Numbers */}
                {getPageNumbers().map((page, index) =>
                  page === "..." ? (
                    <li key={index} className="page-item disabled">
                      <span className="page-link">...</span>
                    </li>
                  ) : (
                    <li
                      key={index}
                      className={`page-item ${currentPage === page ? "active" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    </li>
                  )
                )}

                {/* Next */}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link" onClick={goToNextPage}>
                    Next →
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </>
      )}
    </div>
  );
};

export default SupplierListing;
